import logo from "./logo.svg";
import "./App.css";
import React, { useEffect, useState } from "react";
import SplashScreen from "./Components/SplashScreen/SplashScreen";
import Route from "./Components/AppRoutes";
import Loader from "./Components/Loader/Loader";
import { useSelector } from "react-redux";
import { BASE_URL } from './constants';

function App() {
  const [showLoader, setShowLoader] = useState(false);

  const isShowLoader = useSelector((state) => state.main.IsShowLoader);
  const isProductAdded = useSelector((state) => state.main.IsProductAdded);
  const addedProductName = useSelector((state) => state.main.addedProductName);
  useEffect(() => {
    setShowLoader(isShowLoader);
  }, [isShowLoader]);



  return (
    <div>
      {isProductAdded && (
        <div className="success-popup-upper">
          <div className="success-popup">
            <img src={`${BASE_URL}/assets/images/tick.png`} />
            <h5>Se ha agregado</h5>
            <p>1 {addedProductName}</p>
          </div>
        </div>
      )}
      {showLoader && <Loader />}
      <Route />
    </div>
  );
}

export default App;
